import { render, staticRenderFns } from "./ModeChoice.vue?vue&type=template&id=efd74b02"
import script from "./ModeChoice.vue?vue&type=script&lang=js"
export * from "./ModeChoice.vue?vue&type=script&lang=js"
import style0 from "./ModeChoice.vue?vue&type=style&index=0&id=efd74b02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports